import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { readConsent, setConsent } from "@/lib/analytics";

export const OPEN_COOKIE_SETTINGS = "interoform-open-cookie-settings";

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS));

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (!readConsent()) setOpen(true);
    const onOpen = () => {
      setAnalytics(!!readConsent()?.analytics);
      setDetails(true);
      setOpen(true);
    };
    window.addEventListener(OPEN_COOKIE_SETTINGS, onOpen);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS, onOpen);
  }, []);

  if (!open) return null;

  const decide = (value: boolean) => {
    setConsent(value);
    setOpen(false);
    setDetails(false);
  };

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-title"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-background/95 backdrop-blur-md shadow-lg"
    >
      <div className="container py-5 md:py-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between md:gap-10">
          <div className="max-w-2xl">
            <p className="font-['Barlow_Condensed'] text-xs uppercase tracking-[0.2em] text-accent">Zasebnost</p>
            <h2 id="cookie-title" className="mt-1 font-serif text-xl text-foreground">Piškotki na spletni strani</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground/80">
              Nujni piškotki omogočajo delovanje strani. Z vašim soglasjem uporabljamo tudi Google Analytics za anonimno
              merjenje obiska. Oglaševalskih piškotkov ne uporabljamo. Več v{" "}
              <Link to="/pravila-zasebnosti" className="underline underline-offset-2 hover:text-accent">pravilih zasebnosti</Link>.
            </p>

            {details && (
              <div className="mt-4 space-y-3 border-t border-border pt-4">
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">Nujni piškotki</p>
                    <p className="text-xs text-foreground/70">Shranjevanje vaše izbire. Vedno vklopljeni.</p>
                  </div>
                  <Switch checked disabled aria-label="Nujni piškotki" />
                </div>
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">Analitični piškotki</p>
                    <p className="text-xs text-foreground/70">Google Analytics 4 – statistika obiska strani.</p>
                  </div>
                  <Switch checked={analytics} onCheckedChange={setAnalytics} aria-label="Analitični piškotki" />
                </div>
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 sm:flex-row md:shrink-0">
            {details ? (
              <Button variant="outline" onClick={() => decide(analytics)}>Shrani izbiro</Button>
            ) : (
              <Button variant="ghost" onClick={() => setDetails(true)}>Nastavitve piškotkov</Button>
            )}
            <Button variant="outline" onClick={() => decide(false)}>Zavrni neobvezne</Button>
            <Button variant="outline" onClick={() => decide(true)}>Sprejmi vse</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
